import { useInfiniteQuery } from '@tanstack/react-query';
import { get } from 'lodash';

import { USE_QUERY_CONSTANTS } from 'src/constants/constants';
import { ApiRoutes } from '../api/ApiRoutes';
import { useAxios } from '../api/AxiosContext';
import { GalleryProps } from '../api/response';

// const response: { data: GalleryProps } = camelizeKeys({
//   data: {
//     data: [
//       {
//         image: 'https://imagery.go24.tech/media/upload/ServiceCategories/food_20190830172639.png?w=60&fm=webp',
//         alt: 'Lorem ipsum dolor sit amet',
//       },
//       {
//         image: 'https://imagery.go24.tech/media/upload/ServiceCategories/food_20190830172639.png?w=60&fm=webp',
//         alt: 'Lorem ipsum dolor sit amet',
//       },
//       {
//         image: 'https://imagery.go24.tech/media/upload/ServiceCategories/food_20190830172639.png?w=60&fm=webp',
//         alt: 'Lorem ipsum dolor sit amet',
//       },
//       {
//         image: 'https://imagery.go24.tech/media/upload/ServiceCategories/food_20190830172639.png?w=60&fm=webp',
//         alt: 'Lorem ipsum dolor sit amet',
//       },
//       {
//         image: 'https://imagery.go24.tech/media/upload/ServiceCategories/food_20190830172639.png?w=60&fm=webp',
//         alt: 'Lorem ipsum dolor sit amet',
//       },
//       {
//         image: 'https://imagery.go24.tech/media/upload/ServiceCategories/food_20190830172639.png?w=60&fm=webp',
//         alt: 'Lorem ipsum dolor sit amet',
//       },
//       {
//         image: 'https://imagery.go24.tech/media/upload/ServiceCategories/food_20190830172639.png?w=60&fm=webp',
//         alt: 'Lorem ipsum dolor sit amet',
//       },
//       {
//         image: 'https://imagery.go24.tech/media/upload/ServiceCategories/food_20190830172639.png?w=60&fm=webp',
//         alt: 'Lorem ipsum dolor sit amet',
//       },
//       {
//         image: 'https://imagery.go24.tech/media/upload/ServiceCategories/food_20190830172639.png?w=60&fm=webp',
//         alt: 'Lorem ipsum dolor sit amet',
//       },
//       {
//         image: 'https://imagery.go24.tech/media/upload/ServiceCategories/food_20190830172639.png?w=60&fm=webp',
//         alt: 'Lorem ipsum dolor sit amet',
//       },
//       {
//         image: 'https://imagery.go24.tech/media/upload/ServiceCategories/food_20190830172639.png?w=60&fm=webp',
//         alt: 'Lorem ipsum dolor sit amet',
//       },
//       {
//         image: 'https://imagery.go24.tech/media/upload/ServiceCategories/food_20190830172639.png?w=60&fm=webp',
//         alt: 'Lorem ipsum dolor sit amet',
//       },
//       {
//         image: 'https://imagery.go24.tech/media/upload/ServiceCategories/food_20190830172639.png?w=60&fm=webp',
//         alt: 'Lorem ipsum dolor sit amet',
//       },
//       {
//         image: 'https://imagery.go24.tech/media/upload/ServiceCategories/food_20190830172639.png?w=60&fm=webp',
//         alt: 'Lorem ipsum dolor sit amet',
//       },
//     ],
//     meta: {
//       current_page: 1,
//       from: 1,
//       path: 'https://https://travel.nham24.com/api/v1/customer/store/1?page=1/api/v1/customer/store/1',
//       per_page: '10',
//       to: 1,
//     },
//   },
// }) as any;

export const useTripGalleryInfiniteQuery = ({ tripId }: { tripId?: string }) => {
  const axios = useAxios();

  // const { data, isLoading, isFetching, isFetchingNextPage, fetchNextPage, hasNextPage, refetch, error, isError } =
  return useInfiniteQuery(
    ['trip-gallery', tripId],
    ({ pageParam = 0 }) => {
      const route = ApiRoutes.tripGallery.replace('{{trip_id}}', tripId || '');
      console.log({ route });
      return axios.get<GalleryProps>(route, {
        // return axios.get<GalleryProps>(ApiRoutes.tripGallery, {
        params: { page: pageParam },
      });
    },
    {
      getNextPageParam: lastPage => {
        if (lastPage?.data?.links?.next) {
          return get(lastPage, 'data.meta.currentPage', 0) + 1;
        }

        return undefined;
      },

      refetchOnWindowFocus: false,
      keepPreviousData: true,
      cacheTime: USE_QUERY_CONSTANTS.cacheMs,
      enabled: false,
    },
  );

  // return {
  //   galleryData: data,
  //   galleryIsLoading: isLoading,
  //   galleryFetching: isFetching,
  //   galleryIsFetchingNextPage: isFetchingNextPage,
  //   galleryFetchNextPage: fetchNextPage,
  //   galleryHasNextPage: hasNextPage,
  //   galleryRefetch: refetch,
  //   galleryError: error,
  //   galleryIsError: isError,
  // };
};
